module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic37.06ab411.woff2";